/*@flow*/
import flash from 'lib/flash';
import { useState } from 'react';

export default function useGeolocate(
  cb?: (number, number) => any
): {| geolocate: () => void, isGeoLocating: boolean |} {
  const [isGeoLocating, setGeolocating] = useState(false);
  const geolocate = () => {
    if (navigator.geolocation) {
      setGeolocating(true);
      new Promise((res, rej) => {
        const opts = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        };
        return navigator.geolocation.getCurrentPosition(res, rej, opts);
      })
        .then((position) => {
          const { latitude: lat, longitude: lng } = position.coords;
          setGeolocating(false);
          cb && cb(lng, lat);
        })
        .catch((e) => {
          setGeolocating(false);
          flash('Unable to find your location.');
          throw e;
        });
    } else {
      flash('Geolocation not supported by your system.');
    }
  };
  return { geolocate, isGeoLocating };
}
